import React from "react";

export default function ReportIncident() {
  return <div>Report Incident here</div>;
}
